import { useCallback, useMemo } from 'react';

import {
  createSpec,
  specTypes,
  useFetch,
  useDataRefId,
  useRefetch,
} from '@bingads-webui-react/overreact';

import {
  fetchRequestContract,
  fetchResponseContract,
} from '../spec/coll-fetch';

import { environmentLookupFn } from '../../../environment/environment-instance';
import type {
  CustomerVariables,
  FetchAndRefetchConfig,
  ReadParameters,
  ReadRequestConfig,
  TimeZone,
} from '../../../types';

const fetchSpec = createSpec(
  fetchRequestContract, fetchResponseContract,
  specTypes.FETCH, null, environmentLookupFn
);
const refetchSpec =
  createSpec(fetchRequestContract, fetchResponseContract, specTypes.REFETCH);

export function useTimeZones(
  dataLocator: CustomerVariables,
  config: FetchAndRefetchConfig<TimeZone, CustomerVariables> = {}
) {
  const dataRefId = useDataRefId(null, environmentLookupFn);

  const defaultConfig = useMemo(() => ({

    fetch: config.fetch || {},

    refetch: config.refetch || {},
  }), [config]);

  const { fetch: fetchConfig, refetch } = defaultConfig;

  const [data, error] = useFetch(dataRefId, fetchSpec, dataLocator, fetchConfig) as [
    TimeZone[] | undefined,
    unknown,
  ];
  const refetchFn = useRefetch(dataRefId, refetchSpec, refetch);

  const read = useCallback((
    param: ReadParameters<CustomerVariables> = {},
    requestConfig?: ReadRequestConfig<TimeZone, CustomerVariables>
  ) => {
    refetchFn({
      variables: { ...dataLocator, ...param.variables },
    }, requestConfig);
  }, [dataLocator, refetchFn]);

  return [{ data, error }, { read }];
}
